module.exports = __webpack_public_path__ + "static/media/typing-practice.8aa2b692.jpg";